import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-background-50/80">
      {/* Top section */}
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-18">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <span className="text-lg font-bold text-background-50 whitespace-nowrap">
              Hipobuy <span className="text-accent-300">Spreadsheet</span>
            </span>
            <p className="mt-3 text-sm text-background-50/60 leading-relaxed max-w-xs">
              L&apos;outil d&apos;analyse de données e-commerce qui transforme vos chiffres en décisions rentables.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-xs font-semibold text-background-50/50 uppercase tracking-wider mb-4 whitespace-nowrap">Liens Rapides</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Accueil</Link>
              <Link to="/article/guide-hipobuy-spreadsheet" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Guide Complet</Link>
              <a href="#categories" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Catégories</a>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Site Principal</a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-xs font-semibold text-background-50/50 uppercase tracking-wider mb-4 whitespace-nowrap">Catégories Populaires</h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Shoes</a>
              <a href="https://kaspreadsheet.com/category-913-T-Shirts.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">T-Shirts</a>
              <a href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Hoodies/Sweaters</a>
              <a href="https://kaspreadsheet.com/category-914-Jackets.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Jackets</a>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-xs font-semibold text-background-50/50 uppercase tracking-wider mb-4 whitespace-nowrap">Restez Informé</h4>
            <p className="text-sm text-background-50/60 mb-3 leading-relaxed">
              Recevez nos conseils et astuces pour optimiser votre e-commerce.
            </p>
            <form
              data-readdy-form="true"
              action="https://readdy.ai/api/form/d8t4qu1d9m2hsn3jsbtg"
              method="POST"
              className="flex flex-col gap-2"
            >
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" />
              <div className="flex">
                <input
                  type="email"
                  name="email"
                  placeholder="Votre email"
                  className="flex-1 bg-background-50/10 border border-background-50/20 rounded-l-lg px-4 py-2.5 text-sm text-background-50 placeholder-background-50/40 outline-none focus:border-background-50/50 transition-colors"
                  required
                />
                <button
                  type="submit"
                  className="bg-accent-500 text-background-50 px-4 rounded-r-lg hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom brand strip */}
      <div className="border-t border-background-50/10 px-4 md:px-6 py-6">
        <div className="max-w-[1280px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} Hipobuy Spreadsheet. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">Site Principal</a>
            <Link to="/article/guide-hipobuy-spreadsheet" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">Guide</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}